import React from 'react'
import styled from '@emotion/styled'

import DoneModal from '../../generic/modals/DoneModal'
import { ModalContentNormal } from '../../generic/Basics'

export default ({ setShowModal }) => {
  return (
    <DoneModal name={'photoGuidelines'} title={'Photo Guidelines'} onClick={e => setShowModal(false)} informational={false}>
      <ModalContentNormal>
        <StyledList>
          <SpacedListItem>Upload only one photo per section of the vehicle (driver's side, dashboard), up to 15MB each. Acceptable file types are jpg and png.</SpacedListItem>
          <SpacedListItem>Make sure there's clear lighting without shadows (as much as possible).</SpacedListItem>
          <SpacedListItem>All photos must be your own.</SpacedListItem>
          <SpacedListItem>Vehicle photos only please.</SpacedListItem>
        </StyledList>
      </ModalContentNormal>
    </DoneModal>
  )
}
const StyledList = styled.ul`
  padding-right: 20px;
`
const SpacedListItem = styled.li`
  text-align: left;
  margin: 15px 0;
`
